import React, { useState } from "react";
import { Drawer, Fab, Button, Box, Stack, Typography, Divider } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useRightPanel } from "../pages/Main";

const BottomSheet = ({ buttonGroups, zIndex = 1000, offsetRight }) => {
  const [open, setOpen] = useState(false);
  const context = useRightPanel();
  
  // Usar el offsetRight del contexto si no se pasa como prop
  const finalOffsetRight = offsetRight !== undefined ? offsetRight : (context?.offsetRight || 0);

  const toggleDrawer = (openState) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(openState);
  };

  return (
    <>
      {!open && (
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 12, sm: 16 },
            right: {
              xs: `calc(12px + ${finalOffsetRight}px)`,
              sm: `calc(16px + ${finalOffsetRight}px)`
            },
            zIndex: zIndex,
          }}
        >
          <Fab
            color="primary"
            aria-label="add"
            onClick={toggleDrawer(true)}
            sx={{
              width: { xs: 48, sm: 56 },
              height: { xs: 48, sm: 56 },
              '& .MuiSvgIcon-root': { fontSize: { xs: 24, sm: 28 } }
            }}
          >
            <AddIcon />
          </Fab>
        </Box>
      )}

      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          }
        }}
      >
        <Box
          sx={{
            padding: { xs: 1.5, sm: 2 },
            minHeight: { xs: "160px", sm: "200px" }, 
            backgroundColor: "background.paper",
          }}
          role="presentation"
        >
          {buttonGroups?.map((group, groupIndex) => (
            <Box key={groupIndex}>
              {group.label && (
                <Typography 
                  variant="h6" 
                  sx={{ 
                    mb: { xs: 1.5, sm: 2 },
                    ml: 2,
                    fontSize: { xs: "1rem", sm: "1.25rem" }
                  }}
                >
                  {group.label}
                </Typography>
              )}
              <Stack 
                direction="row"
                spacing={{ xs: 1, sm: 1.5 }}
                justifyContent="flex-start"
                alignItems="center"
                sx={{ ml: 2, mb: { xs: 2, sm: 3 }, flexWrap: 'wrap', rowGap: { xs: 1.5, sm: 2 } }}
              >
                {group.buttons?.map((buttonConfig, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: { xs: 0.5, sm: 1 },
                      width: { xs: 80, sm: 92 },
                      flex: { xs: '0 0 80px', sm: '0 0 92px' }
                    }}
                  >
                    <Fab
                      color={buttonConfig.color || "primary"}
                      onClick={() => {
                        setOpen(false);
                        buttonConfig.action();
                      }}
                      sx={{
                        width: { xs: 48, sm: 56 },
                        height: { xs: 48, sm: 56 },
                        '& .MuiSvgIcon-root': { fontSize: { xs: 22, sm: 24 } }
                      }}
                    >
                      {buttonConfig.icon}
                    </Fab>
                    <Typography
                      variant="caption"
                      align="center"
                      sx={{
                        width: '100%',
                        maxWidth: '100%',
                        whiteSpace: 'normal',
                        lineHeight: 1.2,
                        minHeight: '2.4em',
                        fontSize: { xs: '0.72rem', sm: '0.75rem' },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        textAlign: 'center'
                      }}
                    >
                      {buttonConfig.label}
                    </Typography>
                  </Box>
                ))}
              </Stack>
              {groupIndex < buttonGroups.length - 1 && <Divider sx={{ my: 2 }} />}
            </Box>
          ))}
        </Box>
      </Drawer>
    </>
  );
};

export default BottomSheet;